//29/08  12:41 PM
async function changeDoorFinish(attr) {
    setTimeout(() => {
        attr.click()
        delete window.changeDoorFinish;
    }, 100)
}

//add event listener to swatch adding border when selected
function addActiveEvent(element, activeClass, defaultClass, attrDiv) {
    var activeElements = attrDiv.querySelectorAll("button");
    activeElements.forEach(function(item) {
        item.classList.remove(activeClass);
    });

    if (activeElements.length == 0) {
        var labelElements = attrDiv.querySelectorAll("label");
        labelElements.forEach(function(item) {
            item.classList.remove(activeClass);
            if (item.style.borderTop == '3px solid black') {
                item.style.borderTop = '1px solid rgb(232, 232, 225)'
            }
        });
    }
    element.classList.add(activeClass);
    if (element.style.borderTop == '1px solid rgb(232, 232, 225)') {
        element.style.borderTop = '3px solid black'
    }

}

// filter and render attributes
function filterAttributes(config, finish, className, attribute) {
    window.threekit.configurator.setConfiguration({
        config: finish
    }).then(function() {
        const container = document.querySelector(className);

        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }

        const attributeList = window.threekit.configurator.getDisplayAttributes().find(attr => attr.name === attribute).values
      console.log(attributeList)
        
        attributeList.sort(function(a, b) {
            console.log(a.value, b.value, 'here')
            const textA = a.value.toUpperCase();
            const textB = b.value.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          console.log('ATTRIBUTE LIST ' + attributeList)
        });
        attributeList.forEach(function(value) {
            const attrDiv = document.createElement('div');
            attrDiv.className = 'swatch-container';

            const attrName = document.createElement('p');
            attrName.className = 'swatch-name'
            attrName.innerText = value.value
            attrName.type = 'button';

            const attrValue = document.createElement('label');
            const colorClass = 'label-' + value.value.replace(/\s/g, '-');
            attrValue.className = 'color-swatch ' + colorClass; //+ value.replace(/\s/g, '');
            let color = ''
            if (value.value.includes('Lacquer')) {
                color = value.value.replace(' Lacquer', '');
            } else {
                color = value.value;
            }
            attrValue.style.backgroundImage = 'url( https://cdn.shopify.com/s/files/1/0516/5760/5278/t/29/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png )';
            attrValue.innerText = value.value;

            attrValue.setAttribute('data-config', config);

            attrValue.onmouseenter = (e) => {
                if (document.querySelector('.modal__container')) {
                    document.querySelector('.modal__container').remove();
                }
                // attrValue.onmouseleave = (e) => {
                //     if (document.querySelector('.modal__container') != null) {
                //         document.querySelector('.modal__container').remove();
                //     }
                // }


                const modal = document.createElement('div');
                const viewportW = window.innerWidth;
                modal.className = 'modal__container';
                if (viewportW >= 1600) {
                    modal.style.top = '25%';
                    modal.style.left = '42%';
                } else {
                    modal.style.top = '20%';
                    modal.style.left = '32%';
                }


                const modalTexture = document.createElement('div')
                modalTexture.className = 'modal__texture'
                let color = ''
                if (value.value.includes('Lacquer')) {
                    color = value.value.replace(' Lacquer', '');
                } else {
                    color = value.value;
                }
                                   
                const customURL1 = 'https://cdn.shopify.com/s/files/1/0516/5760/5278/t/29/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png';
                const customURL4 = 'https://cdn.shopify.com/s/files/1/0570/5039/8915/t/3/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png';
                const customURL3 = 'https://cdn.shopify.com/s/files/1/0516/5760/5278/t/25/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png';
                const customURL2 = 'https://cdn.shopify.com/s/files/1/0516/5760/5278/t/34/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png';
                const customURL = validURL(customURL2) ? customURL2 : validURL(customURL4) ? customURL4 : validURL(customURL3) ? customURL3 : customURL1;
                modalTexture.style.backgroundImage = 'url(' + customURL + ')';

                const modalTextContainer = document.createElement('div')
                modalTextContainer.className = 'modal__text-container'

                const modalTitle = document.createElement('h2')
                modalTitle.className = 'modal__text-title'
                modalTitle.textContent = value.value

                const modalDescription = document.createElement('p')
                modalDescription.className = 'modal__description'

                var tooltipClass = "." + value.value.replace(/\s/g, '-') + "-tooltip";
                var toolTip = document.querySelector(tooltipClass);
                var toolTipText = toolTip.getElementsByTagName("input");
                modalDescription.textContent = toolTipText ? toolTipText[0].value : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. '

                modalTextContainer.appendChild(modalTitle)
                modalTextContainer.appendChild(modalDescription)
                modal.appendChild(modalTexture)
                modal.appendChild(modalTextContainer)

                const viewportWidth = window.innerWidth
                if (viewportWidth > 768) {
                    attrDiv.appendChild(modal)
                }
                modal.onmouseleave = () => {
                    attrDiv.removeChild(attrDiv.lastChild)
                }
            }

            attrValue.onclick = function() {
                let modal = document.querySelector('.modal__container')
                if (modal) {
                    attrDiv.removeChild(attrDiv.lastChild)
                }

                changePlayer(attribute, value.value)
                addActiveEvent(this, 'color-swatch-active', '.color-swatch', container)

                var config = attrValue.getAttribute('data-config');
                var itemClass = "." + config.replace(' + ', '-').replace(/\s/g, '-') + "-swatches";
                var itemDiv = document.querySelector(itemClass);
                var itemGroup = itemDiv ? itemDiv.getElementsByTagName("div")[1] : null;

                if (itemGroup) {
                    var keysearch = "input[value='" + value.value + "']";
                    var myitems = itemGroup.querySelectorAll(keysearch);
                    if (myitems.length > 0) {
                        if (!myitems[0].checked) {
                            myitems[0].click();
                        }
                    } else {
                        var itemSelected = [].filter.call(itemGroup.getElementsByTagName("input"), function(input) {
                            return input.value === value.value;
                        });
                        if (itemSelected.length > 0) {
                            if (!itemSelected[0].checked) {
                                itemSelected[0].click();
                            }
                        }
                    }
                }

                //modalMobile 
                const idContainer = '#divContainerModal' + attribute.replace(/\s/g, '');;
                const mobileDivModal = document.querySelector(idContainer);
                if (mobileDivModal) {
                    //texture
                    const texture = mobileDivModal.querySelector('.modal__texture___mobile');
                    if (texture) {
                        let color = ''
                        if (value.value.includes('Lacquer')) {
                            color = value.value.replace(' Lacquer', '');
                        } else {
                            color = value.value;
                        }
                        texture.style.backgroundImage = 'url( https://cdn.shopify.com/s/files/1/0516/5760/5278/t/29/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png )';
                    }
                    //texture
                    //title
                    const title = mobileDivModal.querySelector('.modal__text-title__mobile');
                    if (title) {
                        title.innerText = value.value;
                    }
                    //title
                    //text description
                    const textDescription = mobileDivModal.querySelector('.modal__description__mobile');
                    if (textDescription) {
                        var tooltipClass = "." + value.value.replace(/\s/g, '-') + "-tooltip";
                        var toolTip = document.querySelector(tooltipClass);
                        var toolTipText = toolTip.getElementsByTagName("input");
                        // textDescription.textContent = toolTipText ? toolTipText[0].value : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. '
                        textDescription.textContent = toolTipText[0].value
                    }
                    //text description
                }
            };

            attrDiv.appendChild(attrValue)
            attrDiv.appendChild(attrName)
            container.appendChild(attrDiv);

            //attrDiv.firstChild.click();
        });
        const linkColorDetail = document.createElement('p');
        linkColorDetail.className = 'openModalMobile';
        linkColorDetail.innerText = 'See selection details';

        linkColorDetail.onclick = function() {
            const idContainer = '#divContainerModal' + attribute.replace(/\s/g, '');;
            const divContainerModal = document.querySelector(idContainer);
            const mobileDivModal = document.querySelector('.modal__container__mobile');
            if (linkColorDetail.innerText == 'See selection details') {
                if (divContainerModal) {

                    divContainerModal.classList.remove('hide');
                    linkColorDetail.innerText = 'Close selection details';
                }
            } else {
                if (divContainerModal) {
                    divContainerModal.classList.add('hide');
                    linkColorDetail.innerText = 'See selection details';
                }
            }



        }
        const viewportWidth = window.innerWidth;
        if (viewportWidth <= 768) {
            container.appendChild(linkColorDetail)
        }
    });
}

function openDesk() {
    const closeBtn = document.querySelector('.closeBtn');
    const openBtn = document.querySelector('.openBtn');
    window.threekit.configurator.setConfiguration({
        'Open/Close': 'Open'
    });
    if (closeBtn.classList.contains('closeBtn-active')) {
        closeBtn.classList.remove('closeBtn-active');
        openBtn.classList.add('openBtn-active');
    } else {
        openBtn.classList.add('openBtn-active');
    }
}

function closeDesk() {
    const closeBtn = document.querySelector('.closeBtn');
    const openBtn = document.querySelector('.openBtn');
    window.threekit.configurator.setConfiguration({
        'Open/Close': 'Closed'
    });
    if (openBtn.classList.contains('openBtn-active')) {
        openBtn.classList.remove('openBtn-active');
        closeBtn.classList.add('closeBtn-active');
    } else {
        closeBtn.classList.add('closeBtn-active');
    }
}

function changePlayer(name, value) {
    switch (name) {
        case "Cameras":
            window.threekit.configurator.setConfiguration({
                'Cameras': value
            });
            break;
        case "Change Size":
            window.threekit.configurator.setConfiguration({
                'Change Size': value
            });
            const sizeValue = value + '\"';
            const divsize = document.querySelector("[data-value=" + CSS.escape(sizeValue) + "]");
            var inputSize = divsize.getElementsByTagName("input");
            inputSize[0].click();
            const basePrice = document.querySelector('.product__price').textContent;
            window.localStorage.setItem('basePrice', basePrice);

            break;
        case "Size":
            window.threekit.configurator.setConfiguration({
                'Size': value
            });
            const sizeVal = value + '\"';
            const myDivsize = document.querySelector("[data-value=" + CSS.escape(sizeVal) + "]");
            const divSize = myDivsize ? myDivsize : document.querySelector("[data-value=" + CSS.escape(sizeVal.replace('"', '')) + "]");
            const viewportWidth = window.innerWidth;

            if (divSize != undefined) {
                var inputSizeButton = divSize.getElementsByTagName("input")
                inputSizeButton[0].click();
            } else {
                const sizeField = document.getElementsByName('Size');
                if (sizeField) {
                    const inputFields = sizeField[0].getElementsByTagName('input');
                    if (inputFields) {
                        Array.from(inputFields).forEach(function(mySize) {
                            const sizeValue = mySize.value;
                            const inchValue = sizeValue.split('(');
                            if (inchValue) {
                                if (inchValue[0].replace(/[^0-9\.]+/g, "").replace('.', '') == value.replace(/[^0-9\.]+/g, "")) {
                                    mySize.click();
                                } else {
                                    const chestSize = inchValue[0].split('x');
                                    if (chestSize.length > 0) {
                                        if (chestSize[0] == value) {
                                            mySize.click();
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
            }
            const baseProdPrice = document.querySelector('.product__price').textContent;
            const sizeSelected = document.querySelector('[name=Size]:checked').value;
            window.localStorage.setItem('basePrice', baseProdPrice);
            window.localStorage.setItem('sizeSelected', sizeSelected);
            document.getElementById("threeKitPrice").textContnet = baseProdPrice
            break;
        case "Body Finish":
            window.threekit.configurator.setConfiguration({
                'Body Finish': value
            });
            filterAttributes('Body Finish', value, '.finishesContainer', 'Available Body Finishes');
            var btnClass = ' .btn-' + value;
            const otherButtons = document.querySelectorAll(btnClass);
            otherButtons.forEach(function(attribute) {
                if (attribute != "Body Finish") {
                    attribute.click();
                    //changeDoorFinish(attribute);                                          
                    //setTimeout(() => { attribute.click() }, 1) 
                }
            });
            break;

        case "Base Finish":
            window.threekit.configurator.setConfiguration({
                'Base Finish': value
            });
            filterAttributes('Base Finish', value, '.finishesContainerBase', 'Available Body Finishes');
            var btnClass = ' .btn-' + value;
            const baseButtons = document.querySelectorAll(btnClass);
            baseButtons.forEach(function(attribute) {
                if (attribute.getAttribute('data-config') != "Base Finish") {
                    attribute.click();
                    //changeDoorFinish(attribute);                                          
                    //setTimeout(() => { attribute.click() }, 1) 
                }
            });
            break;

        case "Finish":
            window.threekit.configurator.setConfiguration({
                'Finish': value
            });
            filterAttributes('Finish', value, '.finishesContainerFinish', 'Available Body Finishes');
            var btnClass = ' .btn-' + value;
            const baseButtonsFinish = document.querySelectorAll(btnClass);
            baseButtonsFinish.forEach(function(attribute) {
                if (attribute.getAttribute('data-config') != "Finish") {
                    attribute.click();
                    //changeDoorFinish(attribute);                                          
                    //setTimeout(() => { attribute.click() }, 1) 
                }
            });
            break;


        case "Available Finishes":
            window.threekit.configurator.setConfiguration({
                'Available Finishes': value
            });
            filterAttributes('Available Finishes', value, '.finishesContainerAvailable', 'Available Body Finishes');
            var btnClass = ' .btn-' + value;
            const availableButtons = document.querySelectorAll(btnClass);
            availableButtons.forEach(function(attribute) {
                if (attribute.getAttribute('data-config') != "Available Finishes") {
                    attribute.click();
                }
            });
            break;

        case "Available Body Finishes":
            window.threekit.configurator.setConfiguration({
                'Available Body Finishes': value
            });
            const label = '.label-' + value.replace(/\s/g, '-');
            const otherAttributes = document.querySelectorAll(label);
            otherAttributes.forEach(function(attribute) {
                var config = attribute.getAttribute('data-config');
                if (attribute.getAttribute('data-config') != "Body Finish" && attribute.getAttribute('data-config') != "Base Finish") {
                    attribute.click();
                }
            });
            break;

        case "Door Finish":
            window.threekit.configurator.setConfiguration({
                'Door Finish': value
            }).then(function() {
                filterAttributes('Door Finish', value, '.finishesContainerDoor', 'Available Door Finishes');
            })
            break;
        case "Available Door + Drawer Finishes":
            window.threekit.configurator.setConfiguration({
                'Available Door + Drawer Finishes': value
            }).then(function() {
                filterAttributes('Available Door + Drawer Finishes'.replace('+', ''), value, '.finishesContainerDoorDrawer', 'Available Secondary Finishes');
            })
            break;
        case "Available Door Finishes":
            window.threekit.configurator.setConfiguration({
                'Available Door Finishes': value
            });
            break;
        case "Available Secondary Finishes":
            window.threekit.configurator.setConfiguration({
                'Available Secondary Finishes': value
            });
            break;
        case "Door + Drawer Finish":
            window.threekit.configurator.setConfiguration({
                'Door + Drawer Finish': value
            }).then(function() {
                filterAttributes('Door + Drawer Finish', value, '.finishesContainerDoorDrawer', 'Available Secondary Finishes');
            })
            break;

        case "Secondary Finish":
            window.threekit.configurator.setConfiguration({
                'Secondary Finish': value
            }).then(function() {
                filterAttributes('Secondary Finish', value, '.finishesContainerDoorDrawer', 'Available Secondary Finishes');
            })
            break;
        case "Piping Color":
            window.threekit.configurator.setConfiguration({
                'Piping Color': value
            });
            break;
        case "Piping":
            window.threekit.configurator.setConfiguration({
                'Piping': value
            });
            break;
        case "Fabric":
            window.threekit.configurator.setConfiguration({
                'Fabric': value
            });
            const baseFabricPrice = document.querySelector('.product__price').textContent;
            window.localStorage.setItem('basePrice', baseFabricPrice);
            break;
        case "Drawer Finish":
            window.threekit.configurator.setConfiguration({
                'Drawer Finish': value
            }).then(function() {
                filterAttributes('Drawer Finish', value, '.finishesContainerDoorDrawer', 'Available Secondary Finishes');
            })
            break;
        case "Available Drawer Finishes":
            window.threekit.configurator.setConfiguration({
                'Available Drawer Finishes': value
            });
            break;
        case "Hardware":
            window.threekit.configurator.setConfiguration({
                'Hardware': value
            });
            break;
        // case "Media Options":
        //     addExtrasToPrice()
        //     break;
        default:
            window.threekit.configurator.setConfiguration({
                'Change Size': value
            });
    }
    const pabsolute = document.querySelectorAll('.positionAbsolute');
    if (pabsolute.length > 0) {
        pabsolute.forEach(function(attribute) {
            attribute.classList.add('hide');
        });
        pabsolute[0].classList.remove('hide');
    }
    window.localStorage.setItem('defaultUrl', window.location.href);
    history.replaceState({
        variant: '2',
        source: 'web'
    }, 'test', window.localStorage.firsturl);
}



function getAllAttributes() {
    let index = ''
    const attr = window.threekit.configurator.getAttributes();
    const openClose = window.threekit.configurator.getDisplayAttributes().find(x => x.name === 'Open/Close')
    if (openClose) {
        const divButtons = document.getElementById('openButtons');
        if (divButtons) {
            divButtons.classList.remove("hide");
        }
        const centerDiv = document.querySelector("#myCenterDiv");
        if (centerDiv) {
            centerDiv.style.marginTop = '-100px';
            const three = document.querySelector("#tk-player-component");
            if (three) {
                three.appendChild(centerDiv);
            }
        }

    }
    // MediaOptions()
    const attrContainer = document.getElementById('dynamicAttributes');
    if (attrContainer.childElementCount == 0) {
        const attributes = attr.filter(attribute => attribute.name !== 'Open/Close' && attribute.name !== 'Cameras');
        attributes.forEach(function(attribute) {
            index = document.querySelectorAll('.dropdown-toggle')
            if (attribute.name === "Available Body Finishes") {
                const baseFinishContainer = document.querySelector('#Product-content-BaseFinish');
                const availableFinishesContainer = document.querySelector('#Product-content-AvailableFinishes');
                const bodyFinishContainer = document.querySelector('#Product-content-BodyFinish');
                const finishFinishContainer = document.querySelector('#Product-content-Finish');

                const finishesContainer = document.createElement('div');
                const attrCollapse = document.createElement('div');


                finishesContainer.className = baseFinishContainer ? 'finishesContainerBase' : bodyFinishContainer ? 'finishesContainer' : availableFinishesContainer ? 'finishesContainerAvailable' : finishFinishContainer ? 'finishesContainerFinish' : '';
                finishesContainer.id = 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', '');
                attrCollapse.id = 'atrDiv' + attribute.name;
                attrCollapse.className = 'collapsible-content__inner rte variant-input-wrap';

                finishesContainer.appendChild(attrCollapse)
                if (baseFinishContainer) {
                    baseFinishContainer.appendChild(finishesContainer);
                } else if (availableFinishesContainer) {
                    availableFinishesContainer.appendChild(finishesContainer);
                } else if (bodyFinishContainer) {
                    bodyFinishContainer.appendChild(finishesContainer);
                } else if (finishFinishContainer) {
                    finishFinishContainer.appendChild(finishesContainer);
                }



                //modal mobile
                const viewportWidth = window.innerWidth;
                if (viewportWidth <= 768) {
                    const divContainerModal = document.createElement('div');
                    divContainerModal.id = 'divContainerModal' + attribute.name.replace(/\s/g, '');
                    divContainerModal.className = 'modal__container__mobile hide';

                    const divTextureModal = document.createElement('div');
                    divTextureModal.className = 'modal__texture___mobile';
                    divContainerModal.appendChild(divTextureModal);

                    const divTextContainerModal = document.createElement('div');
                    divTextContainerModal.className = 'modal__text__container__mobile';
                    const divTextTitleModal = document.createElement('h2');
                    divTextTitleModal.className = 'modal__text-title__mobile'
                    divTextTitleModal.innerText = 'Golden Pecan Mappa Burl';
                    divTextContainerModal.appendChild(divTextTitleModal);

                    const divTextDescriptionModal = document.createElement('p');
                    divTextDescriptionModal.className = 'modal__description__mobile';
                    divTextDescriptionModal.innerText = 'Our burl veneers are real wood that come from a unique tree so no two will be alike. Each slice is book matched by out artisans to best showcase the naturally occurring patters in the wood'
                    divTextContainerModal.appendChild(divTextDescriptionModal);

                    const divTextLinkModal = document.createElement('a');
                    divTextLinkModal.className = 'modal__text-link__mobile';
                    divTextLinkModal.href = 'https://scoutdesignstudio.com/collections/finish-samples'
                    divTextLinkModal.target = 'blank'
                    divTextLinkModal.textContent = 'Order finish sample'

                    divTextContainerModal.appendChild(divTextLinkModal);

                    divContainerModal.appendChild(divTextContainerModal);

                    if (baseFinishContainer) {
                        baseFinishContainer.appendChild(divContainerModal);
                    } else if (availableFinishesContainer) {
                        availableFinishesContainer.appendChild(divContainerModal);
                    } else if (bodyFinishContainer) {
                        bodyFinishContainer.appendChild(divContainerModal);
                    } else if (finishFinishContainer) {
                        finishFinishContainer.appendChild(divContainerModal);
                    }
                }
                //modal mobile


            } else if (attribute.name === "Available Door Finishes") {
                const bodyFinishContainer = document.querySelector('#Product-content-DoorFinish');
                const finishesContainer = document.createElement('div');
                finishesContainer.className = 'finishesContainerDoor';
                finishesContainer.id = 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', '');
                const attrCollapse = document.createElement('div');
                attrCollapse.id = 'atrDiv' + attribute.name;
                attrCollapse.className = 'collapsible-content__inner rte variant-input-wrap';

                finishesContainer.appendChild(attrCollapse)
                bodyFinishContainer.appendChild(finishesContainer)

                //modal mobile
                const viewportWidth = window.innerWidth;
                if (viewportWidth <= 768) {
                    const divContainerModal = document.createElement('div');
                    divContainerModal.id = 'divContainerModal' + attribute.name.replace(/\s/g, '');
                    divContainerModal.className = 'modal__container__mobile hide';

                    const divTextureModal = document.createElement('div');
                    divTextureModal.className = 'modal__texture___mobile';
                    divContainerModal.appendChild(divTextureModal);

                    const divTextContainerModal = document.createElement('div');
                    divTextContainerModal.className = 'modal__text__container__mobile';
                    const divTextTitleModal = document.createElement('h2');
                    divTextTitleModal.className = 'modal__text-title__mobile'
                    divTextTitleModal.innerText = 'Golden Pecan Mappa Burl';
                    divTextContainerModal.appendChild(divTextTitleModal);

                    const divTextDescriptionModal = document.createElement('p');
                    divTextDescriptionModal.className = 'modal__description__mobile';
                    divTextDescriptionModal.innerText = 'Our burl veneers are real wood that come from a unique tree so no two will be alike. Each slice is book matched by out artisans to best showcase the naturally occurring patters in the wood'
                    divTextContainerModal.appendChild(divTextDescriptionModal);

                    const divTextLinkModal = document.createElement('a');
                    divTextLinkModal.className = 'modal__text-link__mobile';
                    divTextLinkModal.href = 'https://scoutdesignstudio.com/collections/finish-samples'
                    divTextLinkModal.target = 'blank'
                    divTextLinkModal.textContent = 'Order finish sample'

                    divTextContainerModal.appendChild(divTextLinkModal);

                    divContainerModal.appendChild(divTextContainerModal);

                    if (bodyFinishContainer) {
                        bodyFinishContainer.appendChild(divContainerModal);
                    }

                }
                //modal mobile
            } else if (attribute.name === "Available Drawer Finishes") {
                const bodyFinishContainer = document.querySelector('#Product-content-DrawerFinish');
                const finishesContainer = document.createElement('div');
                finishesContainer.className = 'finishesContainerDrawer';
                finishesContainer.id = 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', '');
                const attrCollapse = document.createElement('div');
                attrCollapse.id = 'atrDiv' + attribute.name;
                attrCollapse.className = 'collapsible-content__inner rte variant-input-wrap';

                finishesContainer.appendChild(attrCollapse)
                bodyFinishContainer.appendChild(finishesContainer)

                //modal mobile
                const viewportWidth = window.innerWidth;
                if (viewportWidth <= 768) {
                    const divContainerModal = document.createElement('div');
                    divContainerModal.id = 'divContainerModal' + attribute.name.replace(/\s/g, '');
                    divContainerModal.className = 'modal__container__mobile hide';

                    const divTextureModal = document.createElement('div');
                    divTextureModal.className = 'modal__texture___mobile';
                    divContainerModal.appendChild(divTextureModal);

                    const divTextContainerModal = document.createElement('div');
                    divTextContainerModal.className = 'modal__text__container__mobile';
                    const divTextTitleModal = document.createElement('h2');
                    divTextTitleModal.className = 'modal__text-title__mobile'
                    divTextTitleModal.innerText = 'Golden Pecan Mappa Burl';
                    divTextContainerModal.appendChild(divTextTitleModal);

                    const divTextDescriptionModal = document.createElement('p');
                    divTextDescriptionModal.className = 'modal__description__mobile';
                    divTextDescriptionModal.innerText = 'Our burl veneers are real wood that come from a unique tree so no two will be alike. Each slice is book matched by out artisans to best showcase the naturally occurring patters in the wood'
                    divTextContainerModal.appendChild(divTextDescriptionModal);

                    const divTextLinkModal = document.createElement('a');
                    divTextLinkModal.className = 'modal__text-link__mobile';
                    divTextLinkModal.href = 'https://scoutdesignstudio.com/collections/finish-samples'
                    divTextLinkModal.target = 'blank'
                    divTextLinkModal.textContent = 'Order finish sample'

                    divTextContainerModal.appendChild(divTextLinkModal);

                    divContainerModal.appendChild(divTextContainerModal);

                    if (bodyFinishContainer) {
                        bodyFinishContainer.appendChild(divContainerModal);
                    }

                }
                //modal mobile
            } else if (attribute.name === "Available Secondary Finishes") {
                const bodyFinishContainer = document.querySelector('#Product-content-DoorDrawerFinish');
                const drawerFinishContainer = document.querySelector('#Product-content-DrawerFinish');
                const secondaryFinishContainer = document.querySelector('#Product-content-SecondaryFinish');
                const finishesContainer = document.createElement('div');
                finishesContainer.className = 'finishesContainerDoorDrawer';
                finishesContainer.id = 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', '').replace('+', '');
                const attrCollapse = document.createElement('div');
                attrCollapse.id = 'atrDiv' + attribute.name;
                attrCollapse.className = 'collapsible-content__inner rte variant-input-wrap';

                finishesContainer.appendChild(attrCollapse)
                if (bodyFinishContainer) {
                    bodyFinishContainer.appendChild(finishesContainer)
                } else if (drawerFinishContainer) {
                    drawerFinishContainer.appendChild(finishesContainer)
                } else if (secondaryFinishContainer) {
                    secondaryFinishContainer.appendChild(finishesContainer)
                }


                //modal mobile
                const viewportWidth = window.innerWidth;
                if (viewportWidth <= 768) {
                    const divContainerModal = document.createElement('div');
                    divContainerModal.id = 'divContainerModal' + attribute.name.replace(/\s/g, '');
                    divContainerModal.className = 'modal__container__mobile hide';

                    const divTextureModal = document.createElement('div');
                    divTextureModal.className = 'modal__texture___mobile';
                    divContainerModal.appendChild(divTextureModal);

                    const divTextContainerModal = document.createElement('div');
                    divTextContainerModal.className = 'modal__text__container__mobile';
                    const divTextTitleModal = document.createElement('h2');
                    divTextTitleModal.className = 'modal__text-title__mobile'
                    divTextTitleModal.innerText = 'Golden Pecan Mappa Burl';
                    divTextContainerModal.appendChild(divTextTitleModal);

                    const divTextDescriptionModal = document.createElement('p');
                    divTextDescriptionModal.className = 'modal__description__mobile';
                    divTextDescriptionModal.innerText = 'Our burl veneers are real wood that come from a unique tree so no two will be alike. Each slice is book matched by out artisans to best showcase the naturally occurring patters in the wood'
                    divTextContainerModal.appendChild(divTextDescriptionModal);

                    const divTextLinkModal = document.createElement('a');
                    divTextLinkModal.className = 'modal__text-link__mobile';
                    divTextLinkModal.href = 'https://scoutdesignstudio.com/collections/finish-samples'
                    divTextLinkModal.target = 'blank'
                    divTextLinkModal.textContent = 'Order finish sample'

                    divTextContainerModal.appendChild(divTextLinkModal);

                    divContainerModal.appendChild(divTextContainerModal);

                    finishesContainer.appendChild(attrCollapse)
                    if (bodyFinishContainer) {
                        bodyFinishContainer.appendChild(divContainerModal)
                    } else if (drawerFinishContainer) {
                        drawerFinishContainer.appendChild(divContainerModal)
                    } else if (secondaryFinishContainer) {
                        secondaryFinishContainer.appendChild(divContainerModal)
                    }

                }
                //modal mobile
            } else if (attribute.name === "Piping Color" || attribute.name === "Hardware" || attribute.name === "Piping" || attribute.name === "Fabric") {
                const attrDiv = document.createElement('div');
                attrDiv.className = 'collapsibles-wrapper collapsibles-wrapper--border-bottom';

                const attrName = document.createElement('button');
                attrName.innerText = attribute.name;
                attrName.type = 'button';
                attrName.className = 'dropdown-toggle label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders collapsible--auto-height';
                attrName.setAttribute('aria-controls', 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', ''));
                attrName.setAttribute('aria-expanded', 'false');

                const indexSpan = document.createElement('span');
                indexSpan.className = 'collapsible-trigger__index';
                indexSpan.innerText = index.length + 1;
                attrName.appendChild(indexSpan);

                const attrSpan = document.createElement('span');
                attrName.appendChild(attrSpan);
                attrSpan.outerHTML = '<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></span>';
                attrDiv.appendChild(attrName);

                const attrValues = document.createElement('div');
                attrValues.className = 'collapsible-content collapsible-content--all';
                attrValues.id = 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', '');

                const attrCollapse = document.createElement('div');
                attrCollapse.id = 'atrDiv' + attribute.name.replace(/\s/g, '').replace('/', '');
                attrCollapse.className = attribute.name === "Hardware" ? 'collapsible-content__inner rte finishesContainerStandar' : 'collapsible-content__inner rte finishesContainerFabric';

                const attrValuesList = attribute.values.filter(value => value !== 'All');
                attrValuesList.forEach(function(value) {
                    if (!attribute.hiddenValues.includes(value)) {
                        const attrDiv = document.createElement('div');
                        attrDiv.className = 'swatch-container';

                        const attrName = document.createElement('p');
                        attrName.className = 'swatch-name'
                        attrName.innerText = value.match(/[A-Z][a-z]+|[0-9]+/g).join(" ")
                        attrName.type = 'button';
                        const attrValue = document.createElement('label');
                        const colorClass = 'label-' + value.replace(/\s/g, '-');
                        attrValue.className = 'color-swatch ' + colorClass; //+ value.replace(/\s/g, '');

                        attrValue.style.borderTop = '1px solid #e8e8e1'
                        let color = ''
                        if (value.includes('Lacquer')) {
                            color = value.replace(' Lacquer', '');
                        } else {
                            color = value;
                        }
                        const customURL1 = 'https://cdn.shopify.com/s/files/1/0516/5760/5278/t/29/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png';
                        const customURL4 = 'https://cdn.shopify.com/s/files/1/0570/5039/8915/t/3/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png';
                        const customURL3 = 'https://cdn.shopify.com/s/files/1/0516/5760/5278/t/25/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png';
                        const customURL2 = 'https://cdn.shopify.com/s/files/1/0516/5760/5278/t/34/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png';
                        const customURL = validURL(customURL4) ? customURL4 : validURL(customURL3) ? customURL3 : validURL(customURL2) ? customURL2 : customURL1;
                      
                        attrValue.style.backgroundImage = 'url(' + customURL + ')';
                        attrValue.innerText = value.match(/[A-Z][a-z]+|[0-9]+/g).join(" ");

                        attrValue.setAttribute('data-config', attribute.name);
                        //tooltip
                        attrValue.onmouseenter = (e) => {
                            if (document.querySelector('.modal__container')) {
                                document.querySelector('.modal__container').remove();
                            }
                            attrValue.onmouseleave = (e) => {
                                if (document.querySelector('.modal__container') != null) {
                                    document.querySelector('.modal__container').remove();
                                }
                            }


                            const modal = document.createElement('div');
                            modal.className = 'modal__container';
                            const viewportW = window.innerWidth;
                            if (viewportW >= 1600) {
                                modal.style.top = '25%';
                                modal.style.left = '42%';
                            } else {
                                modal.style.top = '20%';
                                modal.style.left = '32%';
                            }

                            const modalTexture = document.createElement('div')
                            modalTexture.className = 'modal__texture'
                            let color = ''
                            if (value.includes('Lacquer')) {
                                color = value.replace(' Lacquer', '');
                            } else {
                                color = value;
                            }

                            modalTexture.style.backgroundImage = 'url(' + customURL + ')';

                            const modalTextContainer = document.createElement('div')
                            modalTextContainer.className = 'modal__text-container'

                            const modalTitle = document.createElement('h2')
                            modalTitle.className = 'modal__text-title'
                            modalTitle.textContent = value

                            const modalDescription = document.createElement('p')
                            modalDescription.className = 'modal__description'
                            const modalLink = document.createElement('a')


                            if (attribute.name !== "Hardware") {
                                var tooltipClass = "." + value.replace(/\s/g, '-').replace('---', '-') + "-tooltip";
                                var toolTip = document.querySelector(tooltipClass);
                                var toolTipText = toolTip.getElementsByTagName("input");
                                modalDescription.textContent = toolTipText ? toolTipText[0].value : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. '
                                //modalDescription.textContent = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ';
                                modalLink.className = 'modal__text-link'
                                modalLink.textContent = 'Order fabric sample'
                                modalLink.href = 'https://scoutdesignstudio.com/pages/sample-swatches'
                                modalLink.target = '_blank'
                            }
                            // const modalTriangle = document.createElement('div')
                            // modalTriangle.className = 'modal__triangle'

                            modalTextContainer.appendChild(modalTitle)
                            modalTextContainer.appendChild(modalDescription)
                            modalTextContainer.appendChild(modalLink)
                            modal.appendChild(modalTexture)
                            modal.appendChild(modalTextContainer)
                            // modal.appendChild(modalTriangle)
                            const viewportWidth = window.innerWidth;
                            if (attribute.name != "Hardware" && viewportWidth > 768) {
                                attrContainer.appendChild(modal)
                            }

                            if (viewportWidth > 768) {
                                modal.onmouseleave = () => {
                                    attrContainer.removeChild(attrContainer.lastChild)
                                }
                            }


                        }


                        attrValue.onclick = function() {

                            //CHAGE PRICE 
                            var myConfig = attrValue.getAttribute("data-config");
                            if (myConfig == 'Fabric') {
                                var tooltipClass = value.replace(/\s/g, '-').replace('---', '-') + "-tooltip";
                                var toolTip = document.getElementsByClassName(tooltipClass);
                                if (toolTip.length > 0) {
                                    var toolTipText = toolTip[0].getElementsByTagName("span");

                                    var group = toolTipText[1].getAttribute('data-title');
                                    const myDivsize = document.querySelector("[data-value=" + CSS.escape(group) + "]");
                                    if (myDivsize) {
                                        var inputSizeButton = myDivsize.getElementsByTagName("input")
                                        inputSizeButton[0].click();
                                    }
                                }
                            }

                            const hardwareClass = value.replace(/\s/g, '-') + "-Key";
                            const toolKey = document.getElementsByClassName(hardwareClass);
                            let toolKeyValue = '';
                            let hardwareQuantity = '';
                            if (toolKey.length > 0) {
                                let toolKeyInput = toolKey[0].getElementsByTagName('input');
                                if (toolKeyInput) {
                                    toolKeyValue = toolKeyInput[0].value;

                                    hardwareQuantity = toolKeyInput[0].placeholder;


                                }
                            }

                            if (value !== 'None') {
                                const hardwareKey = toolKeyValue;
                                window.localStorage.setItem('Hardware', hardwareKey);
                                window.localStorage.setItem('HardwareQuantity', hardwareQuantity);
                            } else {
                                window.localStorage.setItem('Hardware', 'null');
                                window.localStorage.setItem('HardwareQuantity', 'null');
                            }


                            const submitBtn = document.querySelector('.add-to-cart')
                            submitBtn.onclick = function() {
                                removeTooltips();
                                const productPrice = document.querySelector('.product__price').textContent.replace(/\s/g, '').replace('$', '')
                                window.localStorage.setItem('productPrice', productPrice);
                                let hardwareId = parseInt(window.localStorage.Hardware)

                                AddToCartVariant(hardwareId)
                            }



                            changePlayer(attribute.name, value)

                            var config = attrValue.getAttribute('data-config');
                            var myDivClass = "#atrDiv" + config.replace(/\s/g, '');
                            var myDivContainer = document.querySelector(myDivClass);
                            addActiveEvent(this, 'color-swatch-active', '.color-swatch', myDivContainer)


                            var itemClass = "." + config.replace(/\s/g, '-') + "-swatches";
                            var itemDiv = document.querySelector(itemClass);
                            var itemGroup = itemDiv ? itemDiv.getElementsByTagName("div")[1] : null;
                            var keysearch = "input[value='" + value + "']";
                            if (itemGroup) {
                                var myitems = itemGroup.querySelectorAll(keysearch);
                                if (myitems.length > 0) {
                                    if (!myitems[0].checked) {
                                        myitems[0].click();
                                    }
                                } else {
                                    var itemSelected = [].filter.call(itemGroup.getElementsByTagName("input"), function(input) {
                                        return input.value === value;
                                    });


                                    if (itemSelected.length > 0) {
                                        if (!itemSelected[0].checked) {
                                            itemSelected[0].click();
                                        }
                                    }
                                }
                            }


                            let modal = document.querySelector('.modal__container')
                            if (modal) {
                                attrContainer.removeChild(attrContainer.lastChild)
                            }

                            const idContainer = '#divContainerModal' + attribute.name.replace(/\s/g, '');;
                            const mobileDivModal = document.querySelector(idContainer);
                            if (mobileDivModal) {
                                //texture
                                const texture = mobileDivModal.querySelector('.modal__texture___mobile');
                                if (texture) {
                                    let color = ''
                                    if (value.includes('Lacquer')) {
                                        color = value.replace(' Lacquer', '');
                                    } else {
                                        color = value;
                                    }
                                    texture.style.backgroundImage = 'url( https://cdn.shopify.com/s/files/1/0516/5760/5278/t/29/assets/' + color.toLowerCase().replace(/\s+/g, '-') + '.png )';
                                }
                                //texture
                                //title
                                const title = mobileDivModal.querySelector('.modal__text-title__mobile');
                                if (title) {
                                    title.innerText = value;
                                }
                                //title
                                //text description

                                const textDescription = mobileDivModal.querySelector('.modal__description__mobile');
                                if (textDescription) {
                                    var tooltipClass = "." + value.replace(/\s/g, '-') + "-tooltip";
                                    var toolTip = document.querySelector(tooltipClass);
                                    var toolTipText = toolTip.getElementsByTagName("input");
                                    textDescription.textContent = toolTipText ? toolTipText[0].value : 'Lorem ipsum dolor sit amet. '
                                }
                                //text description
                            }

                        };
                        attrDiv.appendChild(attrValue);
                        attrDiv.appendChild(attrName);
                        attrCollapse.appendChild(attrDiv);
                    }

                });

                attrValues.appendChild(attrCollapse);
                attrDiv.appendChild(attrValues);
                attrContainer.appendChild(attrDiv);

                const viewportWidthMob = window.innerWidth;
                if (viewportWidthMob <= 768) {

                    // LABEL
                    const linkColorDetail = document.createElement('p');
                    linkColorDetail.className = 'openModalMobile';
                    linkColorDetail.innerText = 'See selection details';
                    linkColorDetail.style.position = 'sticky';

                    linkColorDetail.onclick = function() {
                        const idContainer = '#divContainerModal' + attribute.name.replace(/\s/g, '');
                        const divContainerModal = document.querySelector(idContainer);
                        const mobileDivModal = document.querySelector('.modal__container__mobile');
                        if (linkColorDetail.innerText == 'See selection details') {
                            if (divContainerModal) {

                                divContainerModal.classList.remove('hide');
                                linkColorDetail.innerText = 'Close selection details';
                            }
                        } else {
                            if (divContainerModal) {
                                divContainerModal.classList.add('hide');
                                linkColorDetail.innerText = 'See selection details';
                            }
                        }
                    }

                    if (attribute.name !== 'Hardware') {
                        attrCollapse.appendChild(linkColorDetail);

                    }
                    // LABEL

                    //modal mobile
                    const divContainerModal = document.createElement('div');
                    divContainerModal.id = 'divContainerModal' + attribute.name.replace(/\s/g, '');
                    divContainerModal.className = 'modal__container__mobile hide';

                    const divTextureModal = document.createElement('div');
                    divTextureModal.className = 'modal__texture___mobile';
                    divContainerModal.appendChild(divTextureModal);

                    const divTextContainerModal = document.createElement('div');
                    divTextContainerModal.className = 'modal__text__container__mobile';
                    const divTextTitleModal = document.createElement('h2');
                    divTextTitleModal.className = 'modal__text-title__mobile'
                    divTextTitleModal.innerText = 'Golden Pecan Mappa Burl';
                    divTextContainerModal.appendChild(divTextTitleModal);

                    const divTextDescriptionModal = document.createElement('p');
                    divTextDescriptionModal.className = 'modal__description__mobile';
                    divTextDescriptionModal.innerText = 'toolTipText'
                    divTextContainerModal.appendChild(divTextDescriptionModal);

                    const divTextLinkModal = document.createElement('a');
                    divTextLinkModal.className = 'modal__text-link__mobile';
                    divTextLinkModal.href = 'https://scoutdesignstudio.com/pages/sample-swatches'
                    divTextLinkModal.target = 'blank'
                    divTextLinkModal.textContent = 'Order fabric sample'

                    divTextContainerModal.appendChild(divTextLinkModal);

                    divContainerModal.appendChild(divTextContainerModal);

                    attrDiv.appendChild(divContainerModal);


                    //modal mobile
                }
            } else if (attribute.name === "Media Options") {

                const attrDiv = document.createElement('div');
                attrDiv.className = 'collapsibles-wrapper collapsibles-wrapper--border-bottom';
                const attrName = document.createElement('button');
                attrName.type = 'button';
                attrName.innerText = attribute.name;
                attrName.className = 'dropdown-toggle label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders collapsible--auto-height';
                attrName.setAttribute('aria-controls', 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', '').replace('+', ''));
                attrName.setAttribute('aria-expanded', 'false');

                const indexSpan = document.createElement('span');
                indexSpan.className = 'collapsible-trigger__index';
                indexSpan.innerText = index.length + 1;
                attrName.appendChild(indexSpan);


                const attrSpan = document.createElement('span');
                attrName.appendChild(attrSpan);
                attrSpan.outerHTML = '<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></span>';

                attrDiv.appendChild(attrName);

                const attrValues = document.createElement('div');
                attrValues.className = 'collapsible-content collapsible-content--all';
                attrValues.id = 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', '').replace('+', '');
                const attrCollapse = document.createElement('div');
                attrCollapse.id = 'atrDiv' + attribute.name.replace(/\s/g, '').replace('/', '').replace('+', '');
                attrCollapse.className = 'collapsible-content__inner rte';

                const attrValuesList = attribute.values.filter(value => value !== 'All');
                attrValuesList.forEach(function(value) {
                    if (!attribute.hiddenValues.includes(value)) {

                        const attrValue = document.createElement('input');
                        const attrValueLabel = document.createElement('label');
                        attrValueLabel.className = 'btnMediaOptions ';
                        attrValue.type = 'checkbox';
                        attrValueLabel.type = 'label';
                        var btnClass = ' btn-' + value.replace(/\s/g, '').replace('/', '');

                        attrValue.className = 'btnMediaOptions hide ';
                        attrValue.id = btnClass
                        attrValue.value = value;
                        // Media Option : Left Cabinet [ $50.00 ],Right Cabinet [ $50.00 ]

                        attrValueLabel.setAttribute('for', btnClass)
                        attrValueLabel.innerText = value;

                        attrValueLabel.setAttribute('data-config', attribute.name);
                        attrValueLabel.setAttribute('data-price', value.replace(/[^\d.-]/g, ''));
                        attrValueLabel.onclick = function() {

                            const noneLabel = document.querySelectorAll('.btnMediaOptions')[1];
                            const noneInput = document.querySelectorAll('.btnMediaOptions')[0];
                            const btnMediaOptions = document.querySelectorAll('.btnMediaOptions');

                            if (attrValueLabel.textContent === noneLabel.textContent) {
                                btnMediaOptions.forEach(function(btn) {
                                    if (btn.textContent !== noneLabel.textContent) {
                                        btn.classList.remove('selected');
                                        btn.checked = false;
                                    };
                                })
                                attrValueLabel.classList.add('selected');
                            } else {
                                if (attrValueLabel.classList.contains('selected')) {
                                    attrValueLabel.classList.remove('selected')
                                    attrValue.checked = false;
                                } else {
                                    attrValueLabel.classList.add('selected')
                                    noneLabel.classList.remove('selected');
                                    noneInput.checked = false;
                                }
                            }

                            changePlayer(attribute.name, value)

                            let extras = [];
                            let threekit = [];

                            btnMediaOptions.forEach(function(attribute) {
                                if (attribute.classList.contains('selected')) {
                                    if (attribute.textContent != noneLabel.textContent) {
                                        threekit.push(attribute.textContent.replace('+', '[ ').replace('0', '0.00 ]'))
                                        extras.push(attribute.textContent.replace(/[^\d.-]/g, ''));
                                    }
                                }
                            })

                            let extraPrice = 0;
                            extras.forEach(function(element) {
                                if (element != noneLabel.textContent) {
                                    extraPrice += parseFloat(element);
                                }
                            });


                            const mediaInput = document.querySelector('.mediaHolePrice')
                            mediaInput.value = threekit.join(', ');
                            if (mediaInput.value != '') {
                                mediaInput.checked = true
                            } else {
                                mediaInput.checked = false
                            }

                            const basePrice = window.localStorage.getItem('basePrice').replace(/[^\d.-]/g, '')

                            const totalPrice = parseFloat(basePrice) + extraPrice;
                            document.querySelector('.product__price').textContent = '$' + totalPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            document.querySelector('.product__price2').textContent = '$' + totalPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          
                            window.localStorage.setItem('productPrice', totalPrice.toString());
                            

                        };

                        attrCollapse.appendChild(attrValue);
                        attrCollapse.appendChild(attrValueLabel);

                    }
                });

                const mediaCartInput = document.createElement('input')
                mediaCartInput.type = 'checkbox';
                mediaCartInput.name = 'properties[Media Option]'
                mediaCartInput.className = 'mediaHolePrice hide'
                mediaCartInput.value = ''

                attrValues.appendChild(attrCollapse);
                attrCollapse.appendChild(mediaCartInput);
                attrDiv.appendChild(attrValues);
                attrContainer.appendChild(attrDiv);

            } else {
                const attrDiv = document.createElement('div');
                attrDiv.className = 'collapsibles-wrapper collapsibles-wrapper--border-bottom';
                const attrName = document.createElement('button');
                attrName.type = 'button';
                attrName.innerText = attribute.name;
                attrName.className = 'dropdown-toggle label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders collapsible--auto-height';
                attrName.setAttribute('aria-controls', 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', '').replace('+', ''));
                attrName.setAttribute('aria-expanded', 'false');

                const indexSpan = document.createElement('span');
                indexSpan.className = 'collapsible-trigger__index';
                indexSpan.innerText = index.length + 1;
                attrName.appendChild(indexSpan);


                const attrSpan = document.createElement('span');
                attrName.appendChild(attrSpan);
                attrSpan.outerHTML = '<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></span>';

                attrDiv.appendChild(attrName);

                const attrValues = document.createElement('div');
                attrValues.className = 'collapsible-content collapsible-content--all';
                attrValues.id = 'Product-content-' + attribute.name.replace(/\s/g, '').replace('/', '').replace('+', '');
                const attrCollapse = document.createElement('div');
                attrCollapse.id = 'atrDiv' + attribute.name.replace(/\s/g, '').replace('/', '').replace('+', '');
                attrCollapse.className = 'collapsible-content__inner rte';

                const attrValuesList = attribute.values.filter(value => value !== 'All');

                attrValuesList.forEach(function(value) {
                    if (!attribute.hiddenValues.includes(value)) {
                        const attrValue = document.createElement('button');
                        let attrClassName = ''
                        attrClassName = 'btnSize';
                        attrValue.type = 'button';
                        var btnClass = ' btn-' + value.replace(/\s/g, '').replace('/', '');
                        attrValue.className = attrClassName + btnClass;
                        attrValue.innerText = value;
                        attrValue.setAttribute('data-config', attribute.name);
                        attrValue.onclick = function() {
                            changePlayer(attribute.name, value)
                            if (!this.classList.contains('finishBtn-active')) {
                                addActiveEvent(this, 'finishBtn-active', '.' + attrClassName, attrDiv)
                            }

                            var config = attrValue.getAttribute('data-config');
                            var itemClass = "." + config.replace(/\s/g, '-') + "-swatches";
                            var itemDiv = document.querySelector(itemClass);
                            var itemGroup = itemDiv ? itemDiv.getElementsByTagName("div")[1] : null;
                            if (itemGroup) {
                                var keysearch = "input[value='" + value + "']";
                                var myitems = itemGroup.querySelectorAll(keysearch);
                                if (myitems.length > 0) {
                                    if (!myitems[0].checked) {
                                        myitems[0].click();
                                    }
                                } else {
                                    var itemSelected = [].filter.call(itemGroup.getElementsByTagName("input"), function(input) {
                                        return input.value === value;
                                    });

                                    if (itemSelected.length > 0) {
                                        if (!itemSelected[0].checked) {
                                            itemSelected[0].click();
                                        }
                                    }
                                }
                            }

                        };
                        attrCollapse.appendChild(attrValue);
                    }
                });

                attrValues.appendChild(attrCollapse);
                attrDiv.appendChild(attrValues);
                attrContainer.appendChild(attrDiv);
            }
        })
        const viewportWidth = window.innerWidth;
        if (viewportWidth > 768) {
            defaultThreekitConfiguration();
        } else {
            if (viewportWidth <= 768) {
                defaultThreekitConfiguration();
            }
        }

    }



}
window.onload = function() {
    sessionStorage.setItem('configurator', '');
    const preOrderBtn = document.querySelector('.add-to-cart')
    preOrderBtn.onclick = () => {
        removeTooltips()
        const e = document.querySelectorAll('.ymq-hidden-input')
        e.forEach(function(item) {
            item.remove();
        });
        const mediaOptions = document.querySelector('[name="properties[Media Option]"]')
        mediaOptions.remove();
    }
    window.localStorage.setItem('firsturl', window.location.href);
    const defaultSelectedId = window.localStorage.selectedid;


    const productName = document.querySelector('.product-single__title').textContent.trim()
    window.localStorage.setItem('productName', productName)
    window.localStorage.setItem('Hardware', 'null');
    let viewportWidth = window.innerWidth;
    // let append = 0
    if (viewportWidth <= 768) {
        console.log("YER ON MOBILE")
    } else {
        console.log("YER ON DESKTOP")
    }
    getPrice();
};

function defaultThreekitConfigurationMobile() {
    const config = window.threekit.configurator.getConfiguration();
    const attributes = window.threekit.configurator.getAttributes();
    attributes.forEach(function(item) {
        var defaultConfig = config[item.name];

        var btnClass = '.btn-' + defaultConfig.replace(/\s/g, '').replace('.', '');;
        var myDefaultBtn = document.querySelector(btnClass);
        if (myDefaultBtn) {
            if (item.name != 'Media Options' && item.name != 'Hardware' && item.name != 'Size') {
                if (item.name == myDefaultBtn.getAttribute('data-config')) {
                    myDefaultBtn.click();
                } else {
                    var myBtn = document.querySelectorAll(btnClass);
                    if (myBtn) {
                        if (myBtn.length == 2) {
                            myBtn[1].click();
                        } else {
                            myBtn[0].click();
                        }
                    }
                }
            }
        } else {
            setTimeout(() => {
                defaultThreekitConfigurationSwatches()
            }, 100)
        }
    });
}


function defaultThreekitConfiguration() {
    const config = window.threekit.configurator.getConfiguration();
    const attributes = window.threekit.configurator.getAttributes();
    attributes.forEach(function(item) {
        var defaultConfig = config[item.name];
        var btnClass = '.btn-' + defaultConfig.replace(/\s/g, '').replace('.', '');;
        var myDefaultBtn = document.querySelector(btnClass);
        if (myDefaultBtn) {
            if (item.name != 'Media Options') {
                if (item.name == myDefaultBtn.getAttribute('data-config')) {
                    myDefaultBtn.click();
                } else {
                    var myBtn = document.querySelectorAll(btnClass);
                    if (myBtn) {
                        if (myBtn.length == 2) {
                            myBtn[1].click();
                        } else {
                            myBtn[0].click();
                        }
                    }
                }
            }
        } else {
            setTimeout(() => {
                defaultThreekitConfigurationSwatches()
            }, 100)
        }
    });
}

function defaultThreekitConfigurationSwatches() {

    const config = window.threekit.configurator.getConfiguration();
    const attributes = window.threekit.configurator.getAttributes();
    attributes.forEach(function(item) {
        var defaultConfig = config[item.name];
        var labelClass = '.label-' + defaultConfig.replace(/\s/g, '-').replace('.', '');
        var myDefaultLabel = document.querySelector(labelClass);
        if (myDefaultLabel) {
            const dataConfig = myDefaultLabel.getAttribute('data-config');
            if (item.name == 'Media Options') {
                if (dataConfig == item.name) {
                    myDefaultLabel.click();
                }
            } else {
                if (item.name == 'Fabric' || item.name == 'Piping') {
                    var myBtn = document.querySelectorAll(labelClass);
                    if (myBtn) {
                        myBtn.forEach(function(attr) {
                            const dataConfig = attr.getAttribute('data-config');
                            if (dataConfig == item.name) {
                                attr.click();
                            }
                        });
                    }
                } else {
                    myDefaultLabel.click();
                }
            }

        }
    });
}

function observeTarget(target, action) {
    const optionObserver = {
        root: null,
        rootMargin: '0px',
        threshold: 1
    }
    const optionObserverCallback = function(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                action();
            }
        })
    }
    const observer = new IntersectionObserver(optionObserverCallback, optionObserver)
    observer.observe(target)
}

function getPrice() {
    const attrs = document.querySelectorAll('.btnSize')

    attrs.forEach(attribute => {
        if (attribute.innerText.includes('$')) {
            console.log('found price');
            attribute.innerText = attribute.innerText.replace(/[^0-9]/g, '');
            const price = parseInt(attribute.innerText);
            console.log(price);

        }
    })
}

async function AddToCartVariant(id) {

    const itemsToAdd = document.querySelector('.js-qty__num').value




    const handleQuantity = window.localStorage.HardwareQuantity ? window.localStorage.HardwareQuantity : '1';

    const amount = parseInt(itemsToAdd) * parseInt(handleQuantity)

    try {
        let formData = {
            items: [{
                id: id,
                quantity: amount,

            }, ],
        };
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        });
        const result = await response.json();

        console.log(result);
    } catch (error) {
        console.log(error);
    }
}

const waitForIcons = () => {

    const arBtn_icon__container = document.querySelector('.arIcon___LBllM')

    if (arBtn_icon__container) {

        //new AR button
        arBtn_icon__container.firstChild.remove()
        arBtn_icon__container.innerHTML = '<svg width="24px" height="24px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.17 76.76"><defs><style>.cls-1,.cls-2,.cls-3{fill:none;}.cls-1,.cls-3{stroke:#231f20;stroke-width:3px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{stroke:#a7a9ac;stroke-width:2px;}.cls-3{stroke-linecap:round;stroke-linejoin:round;}</style></defs><polygon class="cls-1" points="50.36 48.36 50.36 28.99 33.59 19.3 16.81 28.99 16.81 48.36 33.59 58.04 50.36 48.36"/><polyline class="cls-1" points="16.81 28.99 33.59 38.67 50.36 28.99"/><line class="cls-1" x1="33.59" y1="58.04" x2="33.59" y2="38.67"/><polygon class="cls-2" points="65.67 57.08 65.67 20.02 33.59 1.5 1.5 20.02 1.5 57.08 33.59 75.6 65.67 57.08"/><polyline class="cls-3" points="40.37 5.41 33.59 1.5 26.66 5.5 33.59 1.5 33.59 11.98"/><polyline class="cls-3" points="58.9 61.45 65.67 57.53 65.67 49.54 65.67 57.53 56.59 52.29"/><polyline class="cls-3" points="8.28 61.45 1.5 57.53 1.5 49.54 1.5 57.53 10.58 52.29"/></svg>'
    } else {
        setTimeout(() => {
            waitForIcons()
        }, 100)
    }
}

const removeThreekitBtnMobile = () => {
    const attr = window.threekit.configurator.getAttributes()
    if (attr === undefined) {
        appendPlayerMobile()

    } else {
        const threekitLogo = document.querySelector('.logo___WOl4T');
        if (threekitLogo) {
            threekitLogo.style.display = 'none';
            getAllAttributes()
        }

    }

}

function removeTooltips() {
    const remove = document.querySelectorAll('.removeTooltip')
    remove.forEach(function(item) {
        item.remove();
    });
}

// const appendPlayerDesktop = () => {
//     const playerBtn = document.querySelectorAll('.button___2vx0y')[1]
//     setTimeout(() => {
//         appendPlayerDesktop()
//     }, 100)

// }

const appendPlayer_Mobile = () => {
    const playerBtn = document.querySelectorAll('.button___2vx0y')[1]
    setTimeout(() => {
        appendPlayer_Mobile()
    }, 100)

}

function validURL(url) {
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();
    return http.status != 404;
}